import { createAction, props } from '@ngrx/store';
import { Form } from '../../../domain/form.interface';

export const newForm = createAction(
  '[FORM] New Form',
  props<{ newForm: boolean }>()
);

export const loadFormsList = createAction(
  '[FORM] Load Forms List'
);

export const loadFormsListSuccess = createAction(
  '[FORM] Load Forms List Success',
  props<{ data: any }>()
);

export const loadFormsListFailure = createAction(
  '[FORM] Load Forms List Failure',
  props<{ error: any }>()
);

export const getSelectedForm = createAction(
  '[FORM] Get Selected Form',
  props<{ form: Form }>()
);

export const getSelectedFormSuccess = createAction(
  '[FORM] Get Selected Form Success',
  props<{ form: Form }>()
);

export const getSelectedFormFailure = createAction(
  '[FORM] Get Selected Form Failure',
  props<{ error: string }>()
);

export const cloneForm = createAction(
  '[FORM] Clone Form',
  props<{ form: Form }>()
);

export const cloneFormSuccess = createAction(
  '[FORM] Clone Form Success',
  props<{ form: Form }>()
);

export const cloneFormFailure = createAction(
  '[FORM] Clone Forms Failure',
  props<{ error: any }>()
);

export const deleteForm = createAction(
  '[FORM] Delete Form',
  props<{ form: Form }>()
);

export const deleteFormSuccess = createAction(
  '[FORM] Delete Form Success',
  props<{ pk: string; sk: string }>()
);

export const deleteFormFailure = createAction(
  '[FORM] Delete Forms Failure',
  props<{ error: any }>()
);

export const addForm = createAction(
  '[FORM] Add Form',
  props<{ form: Form }>()
);

export const addFormSuccess = createAction(
  '[FORM] Add Forms Success',
  props<{ form: Form }>()
);

export const addFormFailure = createAction(
  '[FORM] Add Form Failure',
  props<{ error: any }>()
);

export const editForm = createAction(
  '[FORM] Edit Form',
  props<{ form: Form }>()
);

export const editFormSuccess = createAction(
  '[FORM] Edit Forms Success',
  props<{ form: Form }>()
);
export const editFormFailure = createAction(
  '[FORM] Edit Forms Failure',
  props<{ error: any }>()
);